// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"278":"0e6b8c2e","320":"a9d09278","327":"1a71b14e","609":"7769935a","928":"24c51e41"}[chunkId] + ".css";
};